import {
    AttachmentState,
    AttachmentStateType,
    InlineAttachmentState,
    InlineAttachmentStatus,
    setInlineAttachmentStatus,
    updateAttachment,
} from 'owa-attachment-full-data';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import loc from 'owa-localize';
import { lazyUnsubscribe, NotificationSubscription } from 'owa-notification';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import AttachmentWellViewState from '../../schema/AttachmentWellViewState';
import handleSharingInformation from '../../utils/sharingTips/handleSharingInformation';
import removeAttachmentFromWell from '../removeAttachmentFromWell';
import { setAnnouncedComponentMessage } from '../setAnnouncedComponentMessage';
import updateChangeKeyOnItemId from '../updateChangeKeyOnItemId';
import { messageOnSuccessfulAddingAttachment } from './onAttachmentCreationHandlers.locstring.json';

export function onAttachmentCreationSuccess(
    attachmentState: AttachmentState,
    attachmentInClientId: ClientAttachmentId,
    attachmentInClient: AttachmentType,
    attachmentFromServer: AttachmentType,
    parentItemId: ClientItemId,
    sharingInfoResponse: GetSharingInfoResponse,
    attachmentWell: AttachmentWellViewState
): void {
    // This will trigger the Narrator to announce the message
    setAnnouncedComponentMessage(attachmentWell, loc(messageOnSuccessfulAddingAttachment));

    // 1. Update the attachment in store with the one from server
    // 2. Update the attachmentId in attachmentViewState
    // 3. Initialize attachment policy
    updateAttachment(
        attachmentState,
        attachmentInClientId,
        attachmentInClient,
        attachmentFromServer,
        sharingInfoResponse
    );

    // Update the changeKey
    updateChangeKeyOnItemId(parentItemId, attachmentFromServer.AttachmentId.RootItemChangeKey);

    handleSharingInformation(attachmentState, attachmentInClient, sharingInfoResponse);
}

export function onAttachmentCreationError(
    attachment: AttachmentState,
    attachmentWell?: AttachmentWellViewState,
    subscription?: NotificationSubscription,
    notificationHandler?: (notification: NotificationPayloadBase) => void
): void {
    let shouldRevertSizeChange: boolean = true;
    if (attachment.attachmentType === AttachmentStateType.InlineAttachment) {
        // It's important that this is called before removeAttachmentFromWell
        // so that placeholder can be cleared in compose.
        setInlineAttachmentStatus(
            <InlineAttachmentState>attachment,
            InlineAttachmentStatus.CreateAttachmentFailed
        );
        // If it fails to create an attachment for inline image attachment
        // we will use BASE64 data url instead and we still want to count the size towards the limit
        shouldRevertSizeChange = false;
    }

    if (attachmentWell) {
        removeAttachmentFromWell(attachmentWell, attachment, shouldRevertSizeChange);
    }

    if (subscription && notificationHandler) {
        lazyUnsubscribe.importAndExecute(subscription, notificationHandler);
    }
}
